import React, { useState } from 'react'
import {Modal } from 'antd';
import NewsTypeDesc from './NewsTypeDesc';
function NewsTypeCheck(props) {
    const [open,setOpen] = useState(false)
    return (
        <>
            <a  onClick={() => {setOpen(true)}}>{props.text}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <NewsTypeDesc
                    ent_id={props.ent_id}
                />             
            </Modal>
        </>
    )
}

export default NewsTypeCheck